import React, { Fragment, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import TimezoneSelect, { allTimezones } from 'react-timezone-select';
import { toastr } from 'react-redux-toastr';

import iconCopy from '../../../assets/images/icon_copiar.svg';
import './styles.scss';

import ForceMultiFactorAuth from './ForceMultiFactorAuth';
import { CompanyActions } from '../../../store/actions/companies';

export default () => {
  const [selectedCompany, setSelectedCompany] = useState({
    _id: '',
    fantasyName: '',
    timezone: {
      fusoName: '',
      fuso: '',
    },
    tfa: false,
  });

  const selectedCompanyState = useSelector((state) => state.companies.company);

  const dispatch = useDispatch();
  const { i18n } = useTranslation();

  useEffect(() => {
    if (selectedCompanyState?._id) {
      const { _id, fantasyName, timezone, tfa } = selectedCompanyState;

      setSelectedCompany({
        _id,
        fantasyName,
        timezone: timezone || { fusoName: '', fuso: '' },
        tfa,
      });
    }
  }, [selectedCompanyState]);

  const handleCopyId = () => {
    toastr.success('Mensagem', 'Texto Copiado!');
  };

  const handleChangeTimezone = (e) => {
    setSelectedCompany((prevState) => ({
      ...prevState,
      timezone: { fusoName: e.value, fuso: e.label },
    }));
  };

  const handleChangeTfa = (checked) => {
    setSelectedCompany((prevState) => ({
      ...prevState,
      tfa: checked,
    }));
  };

  const handleUpdateSelectedCompany = () => {
    dispatch(CompanyActions.updateSelectedCompany(selectedCompany));
  };

  if (!selectedCompany?._id) return '';

  return (
    <Fragment>
      <div id={`company-${selectedCompany._id}`}>
        <div className="organizations-content">
          <CopyToClipboard text={selectedCompany._id}>
            <img
              src={iconCopy}
              onClick={handleCopyId}
              className="img-copy-setor"
              title="Copiar id"
              alt=""
            />
          </CopyToClipboard>
          {selectedCompany.fantasyName}
        </div>

        <div className="container-timezone">
          <span>Configuração de timezone:</span>
          <TimezoneSelect
            name="fuso"
            value={selectedCompany.timezone?.fusoName}
            onChange={(e) => handleChangeTimezone(e)}
            timezones={{
              ...allTimezones,
              'America/Noronha': 'Fernando de Noronha',
            }}
          />
        </div>
      </div>

      <ForceMultiFactorAuth
        onChanged={handleChangeTfa}
        value={selectedCompany.tfa}
      />

      <div className="container-timezone-button">
        <button
          onClick={handleUpdateSelectedCompany}
          type="button"
          className="btn btn-primary"
        >
          {i18n.t('salvar')}
        </button>
      </div>
    </Fragment>
  );
};
